import React from 'react'

type Props = {
  onClick: (event: React.MouseEvent) => Promise<void> | void
}

const LendMamorioButton = ({
  onClick,
}: Props) => (
  <button
    type="button"
    className="btn btn-primary"
    onClick={onClick}
    data-testid="lend-mamorio-button"
  >
    このグループのMAMORIOを貸し出す
  </button>
)

export default LendMamorioButton
